/* @flow */
import {
  Accordion,
  AccordionItem,
  AccordionItemBody,
  AccordionItemTitle,
} from 'react-accessible-accordion';
import './Accordion.scss';

export { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle };
